import { useEffect, useState } from "react";
import { useRouter } from "../../hooks/router";
import { translateWord } from "../Util/util";
import { resend_verify_email } from "../../server/requests";

import ErrorMessage from '../AlertMessage/ErrorMessage';

import icon_error from '../AlertMessage/images/error.png'
import icon_success from '../AlertMessage/images/success.png'

var interval

export default function MailVerification({ setPopUpTitles }) {

    const router = useRouter()

    const [message, setMessage] = useState({
        title: '',
        desc: '',
        type: '',
        email: '',
        icon: '',
    })
    const [valueEmail, setValueEmail] = useState('')
    const [messageAlert, setMessageAlert] = useState({
        text: '',
        type: '',
        show: false
    })

    const [time, setTime] = useState(5)

    useEffect(() => {

        setPopUpTitles('E-mail Verification')

        if (router.query.m && router.query.type) {

            let obj

            if (router.query.type === 'error') {

                obj = {
                    title: 'Your email verification has failed.',
                    desc: router.query.m,
                    type: 'error',
                    email: router.query.mail,
                    icon: icon_error
                }

                if (router.query.mail && router.query.mail != 'null') setValueEmail(router.query.mail)

            } else {

                obj = {
                    title: 'Your email has been verified successfully',
                    desc: router.query.m,
                    type: 'success',
                    email: '',
                    icon: icon_success
                }

                redirect_to()

            }

            setMessage(obj)

        }

    }, [router.query]);

    const redirect_to = () => {

        clearInterval(interval)

        let _time = 5

        interval = setInterval(() => {

            _time--

            setTime(_time)

            if (_time == 0) {
                clearInterval(interval)
                window.location.href = (window.location.origin || 'watch.tivimivi.com')
            }

        }, 1000)

    }

    const btn_resend_verify = () => {

        resend_verify_email({ email: valueEmail }, res => {

            setMessageAlert({
                text: res,
                type: 'success',
                show: true
            })

            hide_mesaage()

        }, err => {

            router.push('/auth/mail-verification?m=' + translateWord(err) + '&type=error&mail=' + valueEmail)

        })

    }

    const hide_mesaage = () => {

        setTimeout(() => {
            setMessageAlert({
                text: '',
                type: '',
                show: false
            })

            router.push('/auth/mail-verify')


        }, 3000)
    }

    return (
        <>
            <ErrorMessage text={messageAlert.text} type={messageAlert.type} show={messageAlert.show} />

            <div className="main_mail_verification">

                <div className="main_message_title">
                    <img src={message.icon} className="icon_title_message" />
                    <p className={"title_message " + message.type}>{translateWord(message.title)}</p>
                </div>

                <div className="description_message_verify"> {message.desc}</div>

                {message.type === 'success' ?
                    <p className="time_to_succes">
                        {translateWord('Redirecting to')} <span>{(window.location.origin || 'watch.tivimivi.com')} </span>{translateWord('in')}   <span>{time}</span> {translateWord('seconds')}
                    </p>
                    :
                    <div className="main_resend_field">origin
                        <input type="text" value={valueEmail} onChange={(e) => setValueEmail(e.target.value)} />
                        <button onClick={btn_resend_verify}>{translateWord('Resend')}</button>
                    </div>
                }

            </div>

        </>
    )
}